export { default } from './es/icons/QuestionOutlined';